module.exports = __webpack_public_path__ + "img/istd-white.069e85f2.png";